module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-tree-container"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    staticStyle: {
      "padding-top": "15px",
      "margin-left": "20px"
    }
  }, [_c('el-upload', {
    staticClass: "fl",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addPirce
    }
  }, [_vm._v("添加活动")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.showTempImg
    }
  }, [_vm._v("模板样式说明")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.reviewList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "活动名称",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "msg",
      "label": "活动说明",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "开始时间",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n       " + _vm._s(_vm._f("datetime")(scope.row.start_time, 'yyyy-MM-dd hh:mm')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "end_time",
      "label": "结束时间",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n       " + _vm._s(_vm._f("datetime")(scope.row.end_time, 'yyyy-MM-dd hh:mm')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showreviewDetail(scope.row.id)
            }
          }
        }, [_vm._v("\n           查看活动商品\n         ")]), _vm._v(" "), _c('span'), _vm._v(" "), _c('el-upload', {
          attrs: {
            "on-change": _vm.upPrice,
            "auto-upload": false,
            "show-file-list": false
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.selectTid(scope.row.id)
            }
          }
        }, [_vm._v("上传活动商品及价格")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "模板格式 文件名称格式x年x月x日商品审核.xlsx",
      "visible": _vm.dialogS
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogS = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.tempImg
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.hideTmp
    }
  }, [_vm._v("下载模板")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eaa7b3a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaa7b3a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/priceview.vue
// module id = 2964
// module chunks = 0